(function ($) {
  mm4colV1 = {
    formatter: $('.mm_4col_v1')
  };

  Drupal.behaviors.mm4colV1 = {
    get: function (key) {
      return mm4colV1[key];
    },

    set: function (key, val) {
      mm4colV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        thisFormatter.find('.col').first().addClass('first');
        thisFormatter.find('.col').last().addClass('last');
      });
    }
  };
})(jQuery);
